/*****************************************************************
 *  CUSTOMER BUTLER - THE PROPERTY LIST (clean look)               *
 *  File: apps/web/src/pages/customer/PropertyListPage.js          *
 *  Address: /app/properties                                       *
 *  What it does: Zoho's Properties list - Zoho's saved views and  *
 *  columns - in the Butler look, with search, sort and paging.    *
 *  A property is added from its customer's Properties tab, so it  *
 *  always has an owner.                                           *
 *  Reads: the layout door and the property list door.             *
 *  Writes: nothing.                                               *
 *****************************************************************/

import React, { useEffect, useState } from 'react';
import { PageFrame, QuietLine, Notice } from './customerParts';
import { RecordList } from './RecordList';
import { fetchLayout, fetchPropertyPage } from './customerApi';

/* ---- nameForProperty(row) -- Property Name, else the street ---- */
export function nameForProperty(row) {
  const streetLine = [row.addressLine1, row.city, row.state].filter(Boolean).join(', ');

  return row.label || streetLine || 'Unnamed property';
}

/* ---- PropertyListPage({ onChooseSkin }) ------------------------ */
export function PropertyListPage({ onChooseSkin }) {
  const [layout, setLayout] = useState(null);
  const [layoutProblem, setLayoutProblem] = useState('');

  useEffect(() => {
    fetchLayout('Property')
      .then(setLayout)
      .catch(() => setLayoutProblem('The property list could not be loaded. Check the connection and try again.'));
  }, []);

  return (
    <PageFrame onChooseSkin={onChooseSkin}>
      <header className="cb-head">
        <div>
          <h1 className="cb-title">Properties</h1>
          <p className="cb-sub">Add a property from its customer's Properties tab.</p>
        </div>
      </header>

      {layoutProblem ? <Notice tone="bad" icon="warn">{layoutProblem}</Notice> : null}
      {!layout && !layoutProblem ? <QuietLine icon="clock">Loading</QuietLine> : null}

      {layout ? (
        <RecordList
          layout={layout}
          fetchPage={fetchPropertyPage}
          linkFor={(row) => `/properties/${row.id}`}
          nameFallback={nameForProperty}
          searchHint="Search by property name, street, city or zip"
          nounOne="property"
          nounMany="properties"
        />
      ) : null}
    </PageFrame>
  );
}

export default PropertyListPage;
